(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['./create'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory(require('./create'));
    } else {
        root.ES6ishClassError=factory(root.ES6isClassCreate);
    }
})(this,function(create){
        var toString = Object.prototype.toString;

    	function ES6ishClassError( message, child, parent ){
    		this.name = 'ES6ishClassError';
    		Error.prototype.constructor.call( this, message );
    		this.message = message + ' : ' + toString.call( parent );
    		this.child = child;
    		this.parent = parent;
    	};
    	ES6ishClassError.prototype = create( Error.prototype );
    	return ES6ishClassError;
});